// extracted by mini-css-extract-plugin
module.exports = {"content":"e_4","pw-ad-scroll-container":"e_5","pw-in-article":"e_6"};